import { render, staticRenderFns } from "./Banned.vue?vue&type=template&id=35ef058b&"
import script from "./Banned.vue?vue&type=script&lang=js&"
export * from "./Banned.vue?vue&type=script&lang=js&"
import style0 from "./Banned.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports